define('modules/editor/views/property_boxes/page_gtm',['require','exports','module','./base','ldsh!../../templates/property_boxes/page_gtm'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/page_gtm")
  });
});

